import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import { randomInt, downloadAttachment, userItemsPerListMixin } from '@/utils/vuex';
import { mapMutations, mapState, mapGetters } from 'vuex';
import moment from 'moment';
import debounce from 'lodash/debounce';
import listMixin from '../../components/niotaClassic/listMixin';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [true],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewAccountMgmtAccountMgmtLogs',
  mixins: [listMixin, userItemsPerListMixin],
  data: function data() {
    return {
      csvDownloadModal: false,
      csvDownloadModalText: null,
      csvDownloadModalStart: null,
      selected: [],
      expanded: [],
      actionButtons: [{
        icon: 'fal fa-download',
        title: this.$i18n_t('accMgmt.system.downloadAsCsv'),
        valid: true,
        tooltip: this.$i18n_t('accMgmt.system.downloadAsCsv'),
        action: 'runCSVExport'
      }],
      tableOptions: _objectSpread({}, defaultTableOptions),
      search: null,
      tableLoading: false,
      items: [],
      serverItemsLength: -1,
      priorTableOptions: {},
      data: {
        date: Date.now() - 86400000
      },
      selectedTime: null,
      loading: false,
      disableFetchOnCreatedMixin: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), mapGetters({
    userPrimaryScopeIds: 'authentication/primaryScopeIds',
    sessionUserId: 'authentication/userId'
  })), {}, {
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          sortable: true,
          text: this.$i18n_t('Common.serverTime'),
          value: 'createdAt'
        }, {
          sortable: false,
          text: this.$i18n_t('Common.tenant'),
          value: 'tenantName'
        }, {
          sortable: false,
          text: this.$i18n_t('Common.logType'),
          value: 'type'
        }, {
          sortable: false,
          text: this.$i18n_t('Common.action'),
          value: 'action'
        }],
        tableFooterProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  watch: {
    search: debounce(function () {
      // make sure to start a new search with an offset of 0 === page 1
      this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
        page: 1
      });
    }, 500)
  },
  created: function created() {
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  mounted: function mounted() {
    moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language); // TODO: pick the highest primary scope of the user?

    this.data.scopeIds = this.userPrimaryScopeIds;
    this.fetchList();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    fetchList: function fetchList() {
      var _this = this;

      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.tableLoading = true;
      var _this$tableOptions = this.tableOptions,
          sortDesc = _this$tableOptions.sortDesc,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage;
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = page ? page - 1 : 0;
      var usedItemsPerPage = itemsPerPage ? itemsPerPage : defaultItemsPerPage;
      ApiService.fetchActivityLogs(this, _objectSpread(_objectSpread({}, this.data), {}, {
        limit: usedItemsPerPage,
        offset: usedPage * usedItemsPerPage,
        orderAsc: sortDirection === 'ASC',
        search: this.search
      })).then(function (data) {
        _this.items = data.logs;
        _this.serverItemsLength = data.totalCount;
      }).catch(function (error) {
        console.error(error);

        if (error.response && _this.$i18n_t("Error.".concat(error.response.data.message))) {
          _this.$snack(_this.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this.$snack(_this.$i18n_t('Common.errorLoadingData'), 'error');
        }
      }).finally(function () {
        _this.$store.state.app.loading = false;
        _this.tableLoading = false;
      });
    },
    dateTimeChange: function dateTimeChange(dateObject) {
      this.data.date = dateObject.from * 1000;
      this.data.dateEnd = dateObject.to * 1000;
      this.fetchList();
    },
    date: function date(_date) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (_date) {
        // base date on backend UTC time to match actual CSV log export
        return time ? moment(new Date(_date)).format('L LTS') : moment(new Date(_date)).format('L');
      }
    },
    runCSVExport: function runCSVExport() {
      var _this2 = this;

      this.csvDownloadModal = true;

      var changeText = function changeText() {
        var texts = _this2.$i18n_t('accMgmt.system.csvLoadingTexts');

        if (_this2.csvDownloadModalText === null) {
          _this2.csvDownloadModalText = "".concat(texts[0], "\n");
        } else if (_this2.csvDownloadModalText.endsWith('...')) {
          var newText = undefined;

          do {
            newText = texts[randomInt(texts.length - 1)];
          } while (_this2.csvDownloadModalText.startsWith(newText));

          _this2.csvDownloadModalText = "".concat(newText, "\n");
        } else {
          _this2.csvDownloadModalText = "".concat(_this2.csvDownloadModalText, ".");
        }

        _this2.csvDownloadModalStart = setTimeout(changeText, 1500);
      };

      changeText();
      ApiService.downloadActivityLogsCSVExport(this, this.data).then(function (data) {
        _this2.csvDownloadModal = false;
        clearTimeout(_this2.csvDownloadModalStart);
        _this2.csvDownloadModalText = null;
        var startDate = new Date(_this2.data.date);
        var endDate = new Date(_this2.data.dateEnd || new Date());
        var fileName = "n20_logs_".concat(startDate.toISOString(), "_").concat(endDate.toISOString(), ".csv");
        downloadAttachment('text/csv', data, fileName);
      }).catch(function (error) {
        console.error(error);
      });
    }
  })
};